module.exports = __webpack_public_path__ + "static/series_400-b41045ea68fca44910cb2602368ae59e.png";